<ng-container>

    <mat-tree [dataSource]="thesaurusDataSource" [childrenAccessor]="childrenAccessor" #tree class="thesaurus-tree">

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <div class="mat-tree-node">
                <button id="mat-tree-node-{{node.termOrdinal}}{{utilitiesService.getPathIdentifier(node.paths)}}" matTreeNodeToggle [attr.aria-label]="'toggle ' + node?.name" class="plusMinus" (click)="handleNodeChange(node)" (keydown.enter)="handleNodeChange(node)" tabindex="0">
                    <span *ngIf="!tree?.isExpanded(node)" class="expandIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="currentColor" class="bi bi-plus-square" viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                        </svg>
                    </span>
                    <span *ngIf="tree?.isExpanded(node)" class="collapseIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="currentColor" class="bi bi-dash-square" viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
                    </svg>
                    </span>
                </button>
                <div id="termName">
                    <div *ngIf="isUseForTerm && isDisplayTerm(node); then useInsteadName else entryName"></div>
                </div>
                <ng-template #entryName>
                    <app-thesaurus-entry #thesEntry [entry]="node" [isRoot]="isRootNode(node)" [notesId]="utilitiesService.getPathIdentifier(node.paths)" [collapsingNotesId]="utilitiesService.getPathIdentifier(node.paths)" [index]="getId(node)" [explode]="explode" [major]="major && !isRootNode(node)" [linkable]="!isRootNode(node)"></app-thesaurus-entry>
                </ng-template>
                <ng-template #useInsteadName>
                    <app-thesaurus-entry #thesEntry *ngIf="entry" [entry]="node" [notesId]="utilitiesService.getPathIdentifier(node.paths)" [collapsingNotesId]="utilitiesService.getPathIdentifier(node.paths)" [index]="getId(node)" [explode]="explode" [major]="major"></app-thesaurus-entry>
                    <div id="useFor" class="small">
                        {{'useFor' | i18next}} <span class="strong">{{entry.name}}</span>
                    </div>
                </ng-template>
            </div>
            <div class="nested-node" [class.hideNode]="!tree.isExpanded(node)" role="group">
                <ng-container matTreeNodeOutlet></ng-container>
            </div>
        </mat-nested-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: isLeaf">
            <span class="leaf-node-spacer"></span>
            <div id="leafTerm">
                    <div *ngIf="isUseForTerm && isDisplayTerm(node); then useInsteadName else entryName"></div>
                </div>
                <ng-template #entryName>
                    <app-thesaurus-entry #thesEntry [entry]="node" [isRoot]="isRootNode(node)" [notesId]="utilitiesService.getPathIdentifier(node.paths)" [collapsingNotesId]="utilitiesService.getPathIdentifier(node.paths)" [index]="getId(node)" [explode]="explode" [major]="major"></app-thesaurus-entry>
                </ng-template>
                <ng-template #useInsteadName>
                    <app-thesaurus-entry #thesEntry *ngIf="entry" [entry]="node" [notesId]="utilitiesService.getPathIdentifier(node.paths)" [collapsingNotesId]="utilitiesService.getPathIdentifier(node.paths)" [index]="getId(node)" [explode]="explode" [major]="major"></app-thesaurus-entry>
                    <div id="useFor" class="small">
                        {{'useFor' | i18next}} <span class="strong">{{entry.name}}</span>
                    </div>
                </ng-template>
        </mat-tree-node>
    </mat-tree>
</ng-container>